// import abr from "../../../abrCustom.js";
import {AbrController} from 'hls.js/src/controller/abr-controller.js'

const _getContentUrl = player =>
  player.tech_.hls.levels[player.tech_.hls.currentLevel].url[0];

const _getCodec = player =>
  player.tech_.hls.levels[player.tech_.hls.currentLevel].attrs.CODECS;

const _getBandwidth = player =>
  player.tech_.hls.levels[player.tech_.hls.currentLevel].bitrate;


const _getBufferLength = (hls, index = 0) => {
  if (!hls.streamController.mediaBuffer){
    return 0
  }
  else if (index < hls.streamController.mediaBuffer.buffered.length) {
    if (
      hls.media.currentTime >=
        hls.streamController.mediaBuffer.buffered.start(index) &&
      hls.media.currentTime <=
        hls.streamController.mediaBuffer.buffered.end(index)
    ) {
      return (
        hls.streamController.mediaBuffer.buffered.end(index) -
        hls.media.currentTime
      );
    }
    return _getBufferLength(hls, index + 1);
  }
  return undefined;
};

let routineInterval;
// let abr = new AbrController()
const _checkBuffering = (player, stats, lib) => {
  const checkInterval = 500;
  let lastPlayPos = 0;
  let currentPlayPos = 0;
  let bufferingDetected = false;

  const routine = () => {
    currentPlayPos = player.currentTime();
    if (
      lastPlayPos > 0 &&
      !player.paused() &&
      !bufferingDetected &&
      currentPlayPos <= lastPlayPos
    ) {
      stats.setState(Easybroadcast.eblib.manager.PlayingState.BUFFERING);
      stats.incRebuffer();
      console.log("Buffering Detected")
      bufferingDetected = true;
      return;
    }

    if (
      lastPlayPos > 0 &&
      bufferingDetected &&
      !player.paused() &&
      currentPlayPos > lastPlayPos
    ) {
      stats.setState(Easybroadcast.eblib.manager.PlayingState.PLAYING);
      bufferingDetected = false;
    }
    lastPlayPos = currentPlayPos;
  };

  setInterval(() => {
    routine();
  }, checkInterval);
};

const _stopCheckBuffering = () => {
  if (routineInterval) {
    clearInterval(routineInterval);
    routineInterval = undefined;
  }
};

let watchTimerId;
let lastBandwidth;
let lastCodec;

/**
 * Stops watching.
 */
const _stopWatching = () => {
  if (watchTimerId) {
    window.clearInterval(watchTimerId);
    watchTimerId = undefined;
  }
  lastBandwidth = undefined;
  lastCodec = undefined;
};

/**
 * Starts watching playlist bandwidth and codec.
 */
const _startWatching = (player, lib, stats, options ) => {
  if (watchTimerId) {
    _stopWatching();
  }
  let initalTime = performance.now()
  watchTimerId = window.setInterval(() => {
    let actualBandwidth, actualCodec;

    try {
      actualBandwidth = _getBandwidth(player);
      actualCodec = _getCodec(player);
    } catch (error) {
      return;
    }

    if (lastBandwidth && lastBandwidth !== actualBandwidth) {
      console.log(
        `Playlist bandwidth changed from ${lastBandwidth} to ${
          actualBandwidth
        }, re-registering`,
      );
      const finalTime = performance.now() - initalTime
      // console.log("Player stayed in one bitrate for " , finalTime)
      stats.setBandwidthFluctuation()
      initalTime = performance.now()
      // console.log("bandwidth changed",_getContentUrl(player))
      lib.register(actualBandwidth,actualCodec,options.url, true)
      stats.setBandwidth(actualBandwidth)
      // abr.abr.currentBitrate= actualBandwidth
    } else if (lastCodec && lastCodec !== actualCodec) {
      console.log(
        `Codec changed from ${lastCodec} to ${actualCodec}, re-registering`,
      );
      lib.register(actualBandwidth,actualCodec,_getContentUrl(player),true)
    }
    lastBandwidth = actualBandwidth;
    lastCodec = actualCodec;
  }, 2000);
};


/**
 * Create a fake XHR object for VideoJS compatibility.
 */
const _createFakeXHRObject = () => {
  const noop = () => {};

  const xhr = {
    addEventListener: () => {},
    isAborted: false,
    getAllResponseHeaders: () => "",
    open: noop,
    overrideMimeType: noop,
    readyState: 1,
    send: noop,
    setRequestHeader: noop,
  };
  xhr.abort = () => {
    xhr.isAborted = true;
  };
  return xhr;
};

export {
  _getContentUrl,
  _getCodec,
  _getBandwidth,
  _getBufferLength,
  _checkBuffering,
  _startWatching,
  _stopWatching,
  _createFakeXHRObject,
  _stopCheckBuffering,
};



// WEBPACK FOOTER //
// ./src/js/videoJSExtensions/easybroadcast/hlsjs-tools.js